import React from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap-5';

import '../styles/photo_editor.scss';

const stripQueryParams = (url) => {
  return url.split('?')[0];
};

const PhotoEditorServiceModal = ({ show, onHide, onSave, imageUrl, photoEditorUrl }) => {

  const encodedUrl = encodeURIComponent(stripQueryParams(imageUrl));
  const editorUrl = `${photoEditorUrl}?image_url=${encodedUrl}`;

  React.useEffect(() => {
    const messageHandler = (event) => {
      if (photoEditorUrl.startsWith(event.origin)) {
        if (event.data.cancelClicked) {
          onHide();
        } else if (event.data.saveClicked) {
          const formData = new FormData();
          formData.append('upload[file]', event.data.imgBlob);

          axios.post('/uploads', formData).then((response) => {
            onSave(response.data);
          });
        }
      }
    };

    if (show) window.addEventListener('message', messageHandler, false);

    return () => window.removeEventListener('message', messageHandler);
  }, [show, onHide, onSave, photoEditorUrl]);

  return (
    <Modal
      backdrop="static"
      dialogClassName="photo-edit-modal visible-overflow"
      show={show}
      onHide={onHide}
    >
      <Modal.Body className="photo-editor-modal-body">
        {show && (
          <iframe
            name="photo-editor-iframe"
            src={editorUrl}
            style={{ width: '1px', minWidth: '100%', height: '100%' }}
          />)}
      </Modal.Body>
    </Modal>
  );
};

PhotoEditorServiceModal.propTypes = {
  imageUrl: PropTypes.string,
  photoEditorUrl: PropTypes.string,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default PhotoEditorServiceModal;
